import { RouterModule, Routes } from '@angular/router';
import { AuthService } from './shared/services';

import { HomeComponent } from './home';
import { AccountsComponent } from './accounts/accounts.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EmployeesComponent } from './employees/employees.component';
import { AccountingComponent } from './accounting/accounting.component';

import { LocationComponent } from './location/location.component';
import { InventoryComponent } from './inventory/inventory.component';
import { NotificationsComponent } from './notifications';
import { CustomersComponent } from './customers/customers.component';
import { ChatComponent } from './chat/chat.component';
import { ClockInOutComponent } from './clock-in-out/clock-in-out.component';
import { SettingsComponent } from './settings';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'accounts', component: AccountsComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [ AuthService ] },
  { path: 'employees', component: EmployeesComponent, canActivate: [ AuthService ] },
  { path: 'locations', component: LocationComponent, canActivate: [ AuthService ] },
  { path: 'inventory', component: InventoryComponent, canActivate: [ AuthService ] },
  { path: 'accounting', component: AccountingComponent, canActivate: [ AuthService ] },
  { path: 'notifications', component: NotificationsComponent, canActivate: [ AuthService ] },
  { path: 'customers', component: CustomersComponent, canActivate: [ AuthService ] },
  { path: 'chat', component: ChatComponent, canActivate: [ AuthService ] },
  { path: 'clock-in-out', component: ClockInOutComponent, canActivate: [ AuthService ] },
  { path: 'settings', component: SettingsComponent, canActivate: [ AuthService ] },
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.routing.ts